const MAX_WIDTH = 240
const MAX_HEIGHT = 320

/**
 * The width, in px, an image shows at in the thread: as large as fits the caps
 * without changing its shape or scaling it up. Its height follows from the
 * aspect ratio, so the box is the right size before the image loads.
 */
export function fitImage(width: number, height: number): number {
  return Math.min(width, MAX_WIDTH, (MAX_HEIGHT * width) / height)
}
